/* src/views/jour/proto/JourStockProto.jsx — L'ÉCRAN STOCK d'Aujourd'hui,
   transcrit de docs/handoff/aujourdhui-complet.jsx (JourStock). LE DESSIN,
   PAS LA LOGIQUE : deux stats (sous le seuil / suivis), les deux actions
   (dépôt, liste de courses), les trois vues (central / logements / coûts),
   les groupes navy par catégorie et les lignes
   produit à jauge. Styles copiés tels quels ; data-testid ajoutés. */

import React from 'react'
import { StatsTrio, EnTeteGroupe } from './JourChrome'

export function LigneProduit({ nom, pct, sousSeuil, qty, seuil, onOuvrir, testId,
  premiere }) {
  const ton = sousSeuil ? '#b8412b' : '#2f9e6e'
  return (
    <button onClick={onOuvrir} data-testid={testId}
      style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
        textAlign: 'left', background: '#fff', border: 'none', padding: '10px 12px',
        minHeight: '58px', ...(premiere ? {} : { borderTop: '1px solid var(--bord)' }) }}>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', flexShrink: '0',
        background: ton }} />
      <span style={{ flex: '1', minWidth: '0' }}>
        <span style={{ display: 'block', fontSize: '12px', fontWeight: '600',
          color: 'var(--navy-d)' }}>{nom}</span>
        <span style={{ display: 'block', height: '3px', borderRadius: '2px',
          background: '#eef2f6', overflow: 'hidden', marginTop: '5px',
          maxWidth: '110px' }}>
          <span style={{ display: 'block', width: `${pct}%`, height: '100%',
            borderRadius: '2px', background: ton }} />
        </span>
      </span>
      <span style={{ textAlign: 'right', flexShrink: '0' }}>
        <b style={{ display: 'block', fontSize: '13px',
          color: sousSeuil ? '#b8412b' : 'var(--navy-d)' }}>{qty}</b>
        <span style={{ display: 'block', fontSize: '9px',
          color: 'var(--gris-d)' }}>seuil {seuil}</span>
      </span>
      <span style={{ fontSize: '15px', color: 'var(--gris-d)', flexShrink: '0' }}>›</span>
    </button>
  )
}

export function JourStockProto({ stats, onDepot, onCourses, vue, onVue, groupes,
  note, enfantsVue }) {
  return (
    <div className="page">
      <StatsTrio items={[
        { n: stats.sousSeuil, lb: 'Sous le seuil', fond: '#b8412b' },
        { n: stats.suivis, lb: 'Produits suivis', fond: '#3d5166' },
      ]} />
      <div className="act" style={{ margin: '0 0 12px' }}>
        <button className="bt bt-p" data-testid="stock-deposer"
          onClick={onDepot}>Enregistrer un dépôt</button>
        <button className="bt bt-s" data-testid="stock-courses"
          onClick={onCourses}>La liste de courses</button>
      </div>
      <div style={{ display: 'flex', gap: '3px', background: '#eef2f6',
        borderRadius: '10px', padding: '3px', marginBottom: '11px', width: 'fit-content',
        maxWidth: '100%', overflowX: 'auto', scrollbarWidth: 'none',
        touchAction: 'pan-x' }}>
        {[['central', 'Le central'], ['logements', 'Les logements'],
          ['couts', 'Les coûts']].map(([id, lb]) => (
          <button key={id} onClick={() => onVue(id)} data-testid={`stock-vue-${id}`}
            style={vue === id
              ? { flex: '0 0 auto', minHeight: '36px', padding: '0 13px',
                  borderRadius: '8px', fontSize: '12px', whiteSpace: 'nowrap',
                  background: '#fff', color: 'var(--navy-d)', fontWeight: '600',
                  boxShadow: '0 1px 3px rgba(35,50,64,.12)' }
              : { flex: '0 0 auto', minHeight: '36px', padding: '0 13px',
                  borderRadius: '8px', fontSize: '12px', whiteSpace: 'nowrap',
                  color: 'var(--gris)' }}>{lb}</button>
        ))}
      </div>
      {enfantsVue || (
        <>
          {(groupes || []).map((g, gi) => (
            <div className="carte" key={gi}
              style={{ margin: '0 0 9px', padding: '0', overflow: 'hidden' }}>
              <EnTeteGroupe titre={g.titre} sous={g.sous} />
              {g.lignes.map((l, i) => (
                <LigneProduit key={i} premiere={i === 0} {...l} />
              ))}
            </div>
          ))}
          <p className="note">{note}</p>
        </>
      )}
    </div>
  )
}
